import { Box, Carousel, Image, useMediaQueryContext } from "@drone-js/core";
import { useState } from "react";

const learnMoreImageSrc = {
    desktop: [
        "https://cdn6.agoda.net/images/homesOnboarding/import-airbnb-desktop.svg",
        "https://cdn6.agoda.net/images/homesOnboarding/import-bcom-desktop.svg",
    ],
    mobile: [
        "https://cdn6.agoda.net/images/homesOnboarding/import-airbnb-mobile.svg",
        "https://cdn6.agoda.net/images/homesOnboarding/import-bcom-mobile.svg",
    ],
};

const UrlImage = ({ isMobile = false }: { isMobile?: boolean }) => {
    const [carouselIndex, setCarouselIndex] = useState(0);
    return (
        <Carousel
            display="single"
            loading="eager"
            pageControl="below"
            previousNavAttributes={{ "data-element-name": "carousel-buttons", "data-value": carouselIndex.toString() }}
            nextNavAttributes={{ "data-element-name": "carousel-buttons", "data-value": carouselIndex.toString() }}
            onPageChange={(index) => setCarouselIndex(index)}
        >
            {learnMoreImageSrc[isMobile ? "mobile" : "desktop"].map((src) => (
                <Image key={src} objectFit="cover" loading="immediate" src={src} alt="import-example" />
            ))}
        </Carousel>
    );
};

export const InputURLImage = () => {
    const { m: isMoreThanMobileSize } = useMediaQueryContext();
    return (
        <Box qM={{ pt: "32", maxWidth: "848px" }} pt="24">
            <UrlImage isMobile={!isMoreThanMobileSize} />
        </Box>
    );
};
